export default __webpack_public_path__ + "static/media/Rastech-update-1.0bacaff4.jpg";